import type { FeatureFlagKey } from "@regrello/feature-flags-api";
import type { ConditionOperator, ViewFilterModifier } from "@regrello/graphql-api";

/** A type that describes the ways in which a __string__ value can be filtered. */
export type RegrelloFilterDefinition_StringValue = {
  type: "string";
  filter:
    | { operator: "EQUALS"; value: string; modifier?: ViewFilterModifier }
    | { operator: "NOT_EQUALS"; value: string; modifier?: ViewFilterModifier };
};

export const regrelloFilterOperators_StringValue: Record<
  RegrelloFilterDefinition_StringValue["filter"]["operator"],
  true | FeatureFlagKey
> = {
  EQUALS: true,
  NOT_EQUALS: true,
};
export function getRegrelloDefaultFilterDefinitionStringValue(): RegrelloFilterDefinition_StringValue {
  return {
    type: "string",
    filter: {
      operator: "EQUALS",
      value: "",
    },
  };
}
export function getRegrelloFilterDefinitionStringValue(
  operator: ConditionOperator,
  value: string,
): RegrelloFilterDefinition_StringValue | undefined {
  switch (operator) {
    case "EQUALS":
    case "NOT_EQUALS":
      return {
        type: "string",
        filter: {
          operator,
          value,
        },
      };
    default:
      console.warn("Unrecognized operator for string filter:", operator);
      return undefined;
  }
}
